import type { Action } from 'vuex'
import type { State } from './state'

import actionTypes from './actionTypes'

const actions: { [actionTypes: string]: Action<State, any> } = {
  [actionTypes.SET_CANCEL_TEXT]({ commit }, text: string): void {
    commit(actionTypes.SET_CANCEL_TEXT, text)
  },

  [actionTypes.SET_CONFIRM_TEXT]({ commit }, text: string): void {
    commit(actionTypes.SET_CONFIRM_TEXT, text)
  },

  [actionTypes.SET_CONFIRM_MODAL_STATUS]: ({ commit }, status: boolean): void => {
    commit(actionTypes.SET_CONFIRM_MODAL_STATUS, status)
  },

  [actionTypes.SET_CONFIRM_MODAL_TEXT]: ({ commit }, text: string): void => {
    commit(actionTypes.SET_CONFIRM_MODAL_TEXT, text)
  },

  [actionTypes.SET_CALLBACK_TO_CONFIRM_MODAL]: ({ commit }, callback: Function): void => {
    commit(actionTypes.SET_CALLBACK_TO_CONFIRM_MODAL, callback)
  },

  [actionTypes.USE_CALLBACK]: ({ dispatch, state }): void => {
    dispatch(actionTypes.SET_CONFIRM_MODAL_STATUS, false)
    state.callback()
  },

  [actionTypes.SET_USE_SINGLE_BUTTON_STATUS](
    { commit, dispatch },
    status: boolean
  ): void {
    if (!status) {
      dispatch(actionTypes.SET_CONFIRM_TEXT, 'OK')
      dispatch(actionTypes.SET_CANCEL_TEXT, 'キャンセル')
    }

    commit(actionTypes.SET_USE_SINGLE_BUTTON_STATUS, status)
  },

  [actionTypes.SET_SINGLE_BUTTON_WIDTH]({ commit }, width: string): void {
    commit(actionTypes.SET_SINGLE_BUTTON_WIDTH, width)
  },
}

export default actions
